/* eslint-disable */
import { GET_FAQ_LINKS_FAIL, GET_FAQ_LINKS_START, GET_FAQ_LINKS_SUCCESS } from './actions';

const initialState = {
  isLoading: false,
  error: false,
  links: [],
};

export default (state = initialState, { type, response, action }) => {
  const isAbsolute = action?.isAbsolute;

  const absolutLinks = [
    {
      id: 9998,
      name: 'Политика обработки персональных данных',
      url: 'https://kampus.team/absolut/processing_policy_personal_data.pdf',
      position: 100,
    },
    {
      id: 9999,
      name: 'Политика обработки Cookie-файлов',
      url: 'https://kampus.team/absolut/cookies_policy.pdf',
      position: 101,
    },
  ];

  switch (type) {
    case GET_FAQ_LINKS_START:
      return {
        ...state,
        isLoading: true,
        error: false,
      };

    case GET_FAQ_LINKS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        links: !isAbsolute ? response : [...response, ...absolutLinks],
        error: false,
      };

    case GET_FAQ_LINKS_FAIL:
      return {
        ...state,
        isLoading: false,
        links: [],
        error: true,
      };

    default:
      return state;
  }
};
